import { useQuery } from "@tanstack/react-query";
import { Fragment, useEffect } from "react";
import PaginateCard from "../../../components/PaginateCard";
import { getRequestByAuth } from "../../../function/helper";
import useFilters from "../../../hooks/useFilters";
import Footer from "../../../modules/public/footer/footer";
import Menu from "../../../modules/public/menu/menu";
import PayLinkAgentOrdersFilters from "./components/PayLinkAgentOrdersFilters";
import PayLinkAgentOrdersTable from "./components/PayLinkAgentOrdersTable";

export default function PayLinkAgentOrdersPage() {
  const filters = useFilters({
    page: 1,
    items: 10,
  });

  const { data, refetch, isFetching } = useQuery({
    queryKey: ["PayLinkAgentOrdersPage"],
    queryFn: () =>
      getRequestByAuth(
        "/totalpost/v1/payLink/agent/orders",
        filters.getAll()
      ).then(res => {
        if (res && res.status === 200) {
          return res.data;
        }
        return { count: 0, items: [] };
      }),

    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    placeholderData: { count: 0, items: [] },
  });

  useEffect(() => {
    window.sessionStorage.clear();
  }, []);

  return (
    <Fragment>
      <Menu />

      <main className="flex-grow-1 py-5 rtl-all container">
        <h4 className="mb-3">لیست مرسولات ثبت شده با لینک پرداخت</h4>

        <PayLinkAgentOrdersFilters
          filters={filters}
          isFetching={isFetching}
          refetch={() => {
            filters.set("page", 1);
            refetch();
          }}
        />

        <PayLinkAgentOrdersTable
          data={data}
          isFetching={isFetching}
          filters={filters}
          refetch={refetch}
        />

        <PaginateCard
          count={data.count}
          numberItems={filters.get("items")}
          numberPage={filters.get("page")}
          onIndexChoose={page => {
            filters.set("page", page);
            refetch();
          }}
        />
      </main>

      <Footer />
    </Fragment>
  );
}
